package com.nonopn.skywatcher.app.qrcode

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

@Composable
actual fun ScanQrCode(
    modifier: Modifier,
    onScanned: (result: String) -> Boolean
) {
    // NOTHING
}
